export default __webpack_public_path__ + "static/developmental_monitoring-0311524178e571ff1ebedfb5a97c01ad.jpeg";